import PesquisaPage from './pages/PesquisaPage.vue'

const routes = [
  {
    path: 'pesquisa',
    name: 'pesquisa',
    component: PesquisaPage
  }
];

export default routes;